export default __webpack_public_path__ + "static/media/(50).5ad1c962.jpg";